import React from 'react'
import { Logo } from '@/components/Logo'
import { Ico, OAuth } from '@/components/icons'
import { useLang } from '@/lib/lang'

const OAuthButtons = ({ stack = false, a }) => (
  <div style={{ display: "grid", gridTemplateColumns: stack ? "1fr" : "1fr 1fr", gap: 8 }}>
    <button className="oauth-btn"><OAuth.google/> {a.continue_google}</button>
    <button className="oauth-btn"><OAuth.apple/> {a.continue_apple}</button>
    <button className="oauth-btn" style={{ gridColumn: stack ? "auto" : "1 / -1" }}>
      <OAuth.phone/> {a.continue_phone}
    </button>
  </div>
)

const SignInA = () => {
  const { t } = useLang()
  const a = t.acct.auth.common
  const si = t.acct.auth.signin

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", height: "100%", background: "var(--paper)" }}>
      <div style={{ padding: "56px 64px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <div style={{ maxWidth: 380, width: "100%" }}>
          <Logo variant="default" size={28} color="var(--cocoa)" accent="var(--terracotta)"/>
          <div className="font-mono" style={{ fontSize: 11, color: "var(--terracotta)", marginTop: 56, marginBottom: 14, letterSpacing: "0.1em" }}>
            {si.eyebrow}
          </div>
          <h2 className="font-display" style={{ fontSize: 48, fontWeight: 600, letterSpacing: "-0.03em", margin: "0 0 12px", lineHeight: 1 }}>
            {si.title_1}<br/>
            <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{si.title_word}</span>
          </h2>
          <p style={{ fontSize: 15, color: "var(--muted)", margin: "0 0 32px", lineHeight: 1.55 }}>
            {si.blurb}
          </p>

          <OAuthButtons stack={false} a={a}/>
          <div style={{ margin: "20px 0" }}><div className="divider-row">OR EMAIL</div></div>

          <div style={{ display: "grid", gap: 12 }}>
            <div>
              <label className="auth-input-label">{a.email}</label>
              <input className="auth-input" defaultValue="maria@email.com"/>
            </div>
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span className="auth-input-label" style={{ marginBottom: 0 }}>{a.password}</span>
                <a href="#" className="font-mono" style={{ fontSize: 10, color: "var(--terracotta)", textDecoration: "none" }}>{si.forgot_link}</a>
              </div>
              <div style={{ position: "relative" }}>
                <input className="auth-input" type="password" defaultValue="••••••••••" style={{ paddingRight: 44 }}/>
                <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", color: "var(--muted)", cursor: "pointer" }}><Ico.eye/></span>
              </div>
            </div>
          </div>

          <label style={{ display: "flex", gap: 10, alignItems: "center", marginTop: 16, fontSize: 13, color: "var(--cocoa)", cursor: "pointer" }}>
            <div style={{ width: 16, height: 16, borderRadius: 4, background: "var(--terracotta)", color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center" }}><Ico.check width="11" height="11"/></div>
            {si.keep_signed_in}
          </label>

          <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", marginTop: 22 }}>
            {si.sign_in_button} <Ico.arrow/>
          </button>

          <p style={{ fontSize: 13, color: "var(--muted)", marginTop: 28, textAlign: "center" }}>
            {si.new_here} <a href="#" style={{ color: "var(--terracotta)", fontWeight: 600 }}>{si.create_account_link}</a>
          </p>
        </div>
      </div>

      {/* Right hero */}
      <div style={{ background: "var(--cocoa-2)", color: "var(--cream)", padding: 56, display: "flex", flexDirection: "column", justifyContent: "space-between", position: "relative", overflow: "hidden" }} className="grain">
        <div style={{ position: "absolute", inset: 0, opacity: 0.15 }} className="roof-pattern"/>
        <div style={{ position: "relative", zIndex: 2 }}>
          <div className="font-mono" style={{ fontSize: 11, color: "rgba(245,239,230,0.55)" }}>{si.right_eyebrow}</div>
        </div>

        {/* Center card */}
        <div style={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", gap: 18 }}>
          <div style={{ background: "var(--paper)", color: "var(--cocoa)", borderRadius: 18, padding: 22, boxShadow: "0 20px 50px -10px rgba(0,0,0,0.4)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <span className="status-pill pill-upcoming"><span className="dot"/>{si.upcoming}</span>
              <span className="font-mono" style={{ fontSize: 11, color: "var(--muted)" }}>FMC-48217</span>
            </div>
            <div className="font-display" style={{ fontSize: 22, fontWeight: 600, marginBottom: 4, letterSpacing: "-0.015em" }}>
              {si.your_next_visit}
            </div>
            <div style={{ fontSize: 13, color: "var(--muted)", marginBottom: 16 }}>
              {si.next_visit_date}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, paddingTop: 14, borderTop: "1px solid var(--line)" }}>
              <div style={{ width: 32, height: 32, borderRadius: "50%", background: "var(--terracotta)", color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, fontSize: 12 }}>RC</div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>Rico C.</div>
                <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{si.right_subtitle}</div>
              </div>
            </div>
          </div>

          <div style={{ background: "rgba(245,239,230,0.06)", border: "1px solid rgba(245,239,230,0.12)", borderRadius: 14, padding: 18 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span className="font-mono" style={{ fontSize: 10, color: "rgba(245,239,230,0.55)" }}>{si.home_health_score}</span>
              <span className="font-display" style={{ fontSize: 14, color: "#E68A5C" }}>{si.looking_great}</span>
            </div>
            <div style={{ height: 5, background: "rgba(245,239,230,0.1)", borderRadius: 999, overflow: "hidden" }}>
              <div style={{ width: "87%", height: "100%", background: "linear-gradient(90deg, #7A8C6C, #C99A4A 70%, #C2552D)" }}/>
            </div>
            <div className="font-mono" style={{ fontSize: 10, color: "rgba(245,239,230,0.55)", marginTop: 8 }}>{si.items_flagged}</div>
          </div>
        </div>

        <div style={{ position: "relative", zIndex: 2 }}>
          <div className="font-serif" style={{ fontSize: 22, color: "#E68A5C", lineHeight: 1.3, marginBottom: 8, maxWidth: 360 }}>
            {si.quote}
          </div>
          <div className="font-mono" style={{ fontSize: 11, color: "rgba(245,239,230,0.5)" }}>{si.quote_author}</div>
        </div>
      </div>
    </div>
  )
}

export default function SignInPage() {
  return <SignInA />
}
